import { Badge, Button } from '@ibsys/kit';
import { XIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  sourceName?: string;
  onReset: () => void;
};

export const SourceFilter: FC<Props> = ({ sourceName, onReset }) => {
  const { t } = useTranslation('knowledge');

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-muted-foreground">{t('sourceFilterLabel')}</span>
      <Badge variant="secondary" outline className="max-w-full truncate">
        {sourceName || t('sourceFilterFallback')}
      </Badge>
      <Button
        variant="ghost"
        size="icon"
        className="size-6"
        aria-label={t('resetSourceFilter')}
        tooltip={t('resetSourceFilter')}
        icon={<XIcon className="size-4" />}
        onClick={onReset}
      />
    </div>
  );
};
